import { Injectable } from "@angular/core"
import { BehaviorSubject, Subject } from "rxjs"

@Injectable()
export class AlertDialogService {
    public alert = new Subject<any>();
    public observer: any = this.alert.asObservable();
    public data: any = {};

    show(args: any) {
        const loaderEl = document.getElementById("alert-dialog-static-backdrop");
        loaderEl.setAttribute("style", "display: block; z-index: 4000");
        loaderEl.classList.add("show");
        this.alert.next(args);
    }

    hide() {
        const loaderEl = document.getElementById("alert-dialog-static-backdrop");
        loaderEl.setAttribute("style", "display: none;");
        loaderEl.classList.remove("show");
    }

}